import { configureStore } from "@reduxjs/toolkit";
import authReducer from "@/features/auth/authSlice";
import newsLetterSubscriberReducer from "@/store/altingross/news-letter-subscriber";
import campaignsReducer from "@/store/altingross/campaigns";
import herosReducer from "@/store/altingross/heros";
import aboutReducer from "@/store/altingross/about";
import categoriesReducer from "@/store/altingross/categories";
import policiesReducer from "@/store/altingross/policies";
import messagesReducer from "@/store/altingross/messages";
import branchesReducer from "@/store/altingross/branches";
import seoReducer from "@/store/altingross/seo";
import guestsReducer from "@/store/altingross/guests";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    newsLetterSubscriber: newsLetterSubscriberReducer,
    campaigns: campaignsReducer,
    heros: herosReducer,
    about: aboutReducer,
    categories: categoriesReducer,
    policies: policiesReducer,
    messages: messagesReducer,
    branches: branchesReducer,
    seo: seoReducer,
    guests: guestsReducer,
  },

});
